<template>
    <div class="position-box advancedCertification">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="goBack" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="goBack" alt="">
            <div class="title">{{$t('my.sfyz')}}</div>
        </div>
        <div class="cotainer">
            <div class="country-box" @click="goCountry" v-if="lang == 'ar'"><img class="arrow" v-if="theme" src="@/assets/theme/icon_back.png" alt=""><img class="arrow" v-else src="@/assets/alb/icon_back.png"alt=""><input class="input" v-model="country" type="text" readonly :placeholder="$t('level1.qxzgjlb')"><div>{{$t('level1.gjlb')}}</div></div>
             <div class="country-box" @click="goCountry" v-else><div>{{$t('level1.gjlb')}}</div><input class="input" v-model="country" type="text" readonly :placeholder="$t('level1.qxzgjlb')"><img class="arrow" v-if="theme" src="@/assets/theme/jiantou.png" alt=""><img class="arrow" v-else src="@/assets/arrow_right.png"alt=""></div>
            <div class="tips">{{$t('level1.zjlx')}}</div>
            <div class="input-box" @click.stop="down" v-if="lang == 'ar'">
                <img class="down" src="@/assets/down.png" alt="">
                <input class="input" v-model="id_card_name" type="text" readonly :placeholder="$t('level1.qxzzjlx')" autocomplete="off">
            </div>
            <div class="input-box" @click.stop="down" v-else>
                <input class="input" v-model="id_card_name" type="text" readonly :placeholder="$t('level1.qxzzjlx')" autocomplete="off">
                <img class="down" src="@/assets/down.png" alt="">
            </div>
            <div class="tips">{{$t('level1.name')}}</div>
            <div class="input-box"><input class="input" v-model="true_name" type="text" :disabled="base_auth_status == 1 || base_auth_status == 2" :placeholder="$t('level1.input-username')" autocomplete="off"></div>
            <div class="tips">{{$t('level1.zjhm')}}</div>
            <div class="input-box"><input class="input" v-model="id_card" type="text" :disabled="base_auth_status == 1 || base_auth_status == 2" :placeholder="$t('level1.input-idcard')" autocomplete="off"></div>
            <div class="tips" v-show="isBank == 1">{{$t('level1.khh')}}</div>
            <div class="input-box" v-show="isBank == 1"><input class="input" v-model="bank_name" type="text" :disabled="base_auth_status == 1 || base_auth_status == 2" :placeholder="$t('level1.qsrkhh')" autocomplete="off"></div>
             <div class="tips" v-show="isBank == 1">{{$t('level1.yhkh')}}</div>
            <div class="input-box" v-show="isBank == 1"><input class="input" v-model="bank_number" type="text" :disabled="base_auth_status == 1 || base_auth_status == 2" :placeholder="$t('level1.qsryhkh')" autocomplete="off"></div>
            <ul class="item-box">
                <li class="item">
                    <div class="upload-box">
                        <template v-if="base_auth_status == 1 || base_auth_status == 2">
                          <img class="upload-bg" :src="id_card_face" alt="">
                        </template>
                        <template v-else>
                          <template v-if="id_card_face">
                            <img class="upload-bg" :src="id_card_face"  @click="upAvatar(1)" alt="">
                          </template>
                          <template v-else>
                            <img class="upload-bg" v-if="theme" src="@/assets/theme/shangchuan.png"  @click="upAvatar(1)" alt="">
                            <img class="upload-bg" v-else src="@/assets/my2/upload.png"  @click="upAvatar(1)" alt="">
                            <div class="text" @click="upAvatar(1)">{{$t('gjrz.sczjzmz')}}</div>
                          </template>
                        </template>
                    </div>
                    <img class="img" v-if="theme" src="@/assets/theme/beijing1.png" alt="">
                    <img class="img" v-else src="@/assets/my2/upload2.png" alt="">
                </li>
                <li class="item">
                    <div class="upload-box">
                        <template v-if="base_auth_status == 1 || base_auth_status == 2">
                          <img class="upload-bg" :src="id_card_back" alt="">
                        </template>
                        <template v-else>
                          <template v-if="id_card_back">
                            <img class="upload-bg" :src="id_card_back"  @click="upAvatar(2)" alt="">
                          </template>
                          <template v-else>
                            <img class="upload-bg" v-if="theme" src="@/assets/theme/shangchuan.png"  @click="upAvatar(2)" alt="">
                            <img class="upload-bg" v-else src="@/assets/my2/upload.png"  @click="upAvatar(2)" alt="">
                            <div class="text" @click="upAvatar(2)">{{$t('gjrz.sczjbmz')}}</div>
                          </template>
                        </template>
                    </div>
                    <img class="img" v-if="theme" src="@/assets/theme/beijing2.png" alt="">
                    <img class="img" v-else src="@/assets/my2/upload4.png" alt="">
                </li>
                <li class="item" v-show="signature == 1">
                    <div class="upload-box">
                        <template v-if="base_auth_status == 1 || base_auth_status == 2">
                          <img class="upload-bg" :src="id_card_sign" alt="">
                        </template>
                        <template v-else>
                          <template v-if="id_card_sign">
                            <img class="upload-bg" :src="id_card_sign"  @click="upAvatar(3)" alt="">
                          </template>
                          <template v-else>
                            <img class="upload-bg" v-if="theme" src="@/assets/theme/shangchuan.png"  @click="upAvatar(3)" alt="">
                            <img class="upload-bg" v-else src="@/assets/my2/upload.png"  @click="upAvatar(3)" alt="">
                            <div class="text" @click="upAvatar(3)">{{$t('gjrz.scgrqmz')}}</div>
                          </template>
                        </template>
                    </div>
                    <img class="img" v-if="theme" src="@/assets/theme/beijing3.png" alt="">
                    <img class="img" v-else src="@/assets/my2/upload6.png" alt="">
                </li>
            </ul>
            <div class="tips-text">{{$t('gjrz.t1')}}</div>
            <div class="tips-text">{{$t('gjrz.t2')}}</div>
            <div class="tips-text" v-show="signature == 1">{{$t('gjrz.t3')}}</div>
        </div>
        <div class="mask" v-show="isSelect" @click="down"></div>
        <ul class="card-box" v-show="isSelect">
          <li class="card" v-for="(item,index) in idCardArr" :key="index" @click.stop="select(item.id,item.name)">{{item.name}}</li>
        </ul>
        <button class="btn-login btn-bg" v-if="base_auth_status == 1">{{$t('gjrz.shz')}}</button>
        <button class="btn-login btn-bg" v-else-if="base_auth_status == 2">{{$t('gjrz.shtg')}}</button>
        <button class="btn-login btn-bg" v-else @click="submit">{{$t('gjrz.t4')}}</button>
        <div class="load-box" v-show="isLoad" @click="hideLoad"><img class="load" src="@/assets/loading.gif" alt=""></div>
        <input class="___input" type="file" ref="foreheadCir" mutiple="mutiple" accept="image/*" style="display: none;">
    </div>
</template>

<script>
import lrz from "lrz";
export default {
    name: 'advancedCertification',
    data () {
        return {
          lang: 'en',
          isLoad: false,
          imgId: 1,
          theme: false,
          isSelect: false,
          address: '',
          isBank: '',
          token: '',
          country: '',
          true_name: '',
          id_card: '',
          id_card_type: '',
          id_card_name: '',
          bank_name: '',
          bank_number: '',
          idCardArr: '',
          base_auth_status: '',
          id_card_face: '',
					id_card_back: '',
					id_card_sign: '',
          signature: 0,
          count: 1
        }
    },
    created(){
      this.lang = localStorage.getItem('language') || 'en';
      this.token = localStorage.getItem('token');
      this.theme = JSON.parse(localStorage.getItem('theme'));
      this.country = localStorage.getItem('country') || country[0][this.lang];
      this.signature = localStorage.getItem('signature') || 0;
    },
    mounted() {
      this.getBankinfo();
      this.getCenterLevel();
      this.getIdcardType();
    },
    methods: {
       goBack(){
           this.$router.push('/user')
       },
       goCountry(){
        if(this.base_auth_status == 1 || this.base_auth_status == 2) return;
        this.$router.push('/city');
       },
       getBankinfo(){
          this.$ajax.get('/web/hasBankinfo',{}).then((res) => {
              let resData = res.data.data;
              this.isBank = resData;
            }).catch(function(err){
                console.log(err)
            })
				},
        getCenterLevel(){
          let params = {
              level:1
          }
          this.$ajax.get('/web/getCenterLevel',{params}).then((res) => {
              let resData = res.data.data;
              this.true_name = resData.name;
              this.id_card = resData.id_card;
              this.address = resData.address;
              this.id_card_name = resData.card_type_name;
              this.base_auth_status = resData.base_auth_status;
              if(resData.base_auth_status == 1 || resData.base_auth_status == 2){
                this.country = resData.country
              }else{
                this.country = this.country
              }
              this.bank_name = resData.bank_name;
              this.bank_number = resData.bank_number;
              this.id_card_face = resData.id_card_face;
              this.id_card_back = resData.id_card_back;
              this.id_card_sign = resData.id_card_sign;
          }).catch(function(err){
              console.log(err)
          })
        },
       getIdcardType(){
            this.$ajax.get('/web/getIdcardType',{}).then((res) => {
                let resData = res.data.data;
                this.idCardArr = resData;
                if(!this.id_card_type){
                    this.id_card_name = resData[0].name;
                    this.id_card_type = resData[0].id;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       upAvatar(id){
          this.imgId = id;
          this.uploadimg((res) => {

          })
      },
      uploadimg(callback){
        let that = this;
        that.ele_input(function(res) {
          if (res.length > 0) {
            var formdata = new FormData();
            for (var i = 0, len = res.length; i < len; i++) {
              lrz(res[0]).then(function (rst) {
                var formdata = new FormData();
                let file = new window.File([rst.file],rst.origin.name, {type: rst.file.type});
                formdata.append('file', file);
                formdata.append('token', that.token);
                formdata.append('app', 'h5');
                that.isLoad = true;
                $.ajax({
                  url: that.domain + "/web/uploadImg",
                  type: "POST",
                  data: formdata,
                  cache: false,
                  processData: false,
                  contentType: false,
                  success: function(data) {
                    if (typeof data == 'string') data = JSON.parse(data.data)
                    if (data && data.code == 0) {
                      that.isLoad = false;
                      if(that.imgId == 1){
                          that.id_card_face = data.data.url;
                      }else if(that.imgId == 2){
                          that.id_card_back = data.data.url;
                      }else {
                          that.id_card_sign = data.data.url;
                      }
                    }else{
                      that.isLoad = false;
                      that.$toast.center(resData.message);
                      return;
                    }
                  },error: function(data) {
                    that.isLoad = false;
                    that.$toast.center(resData.message);
                    return;
                  }
                });
              })
            }
          }
        })
      },
      ele_input(callback){
        var inputs = document.querySelector('.___input')
        if (!!inputs) {
          inputs.onchange = null
          inputs.onclick = null
        }
        inputs.onchange = function() {
          var arr = []
          for (var i = 0, len = this.files.length; i < len; i++) {
            arr.push(this.files[i])
          }
          callback(arr)
        }
        inputs.click();
      },
      hideLoad(){
          this.isLoad = false
      },
      down(){
        if(this.base_auth_status == 1 || this.base_auth_status == 2) return;
        this.isSelect = !this.isSelect;
      },
      select(id,name){
          this.id_card_type = id;
          this.id_card_name = name;
          this.isSelect = false
      },
      submit(){
        let params = {
          name: this.true_name,
          country: this.country,
          id_card: this.id_card,
          address: this.address,
          level:1,
          id_card_type: this.id_card_type,
          alipay_account: this.alipay_account,
          bank_name: this.bank_name,
          bank_number: this.bank_number,
          id_card_face: this.id_card_face,
          id_card_back: this.id_card_back,
          id_card_sign: this.id_card_sign
        }
        if(!this.country){
            this.$toast.center(this.$t('level1.qxzgjlb'));
            return false;
        }
        if(!this.id_card_name || this.id_card_name == null){
            this.$toast.center(this.$t('level1.qxzzjlx'));
            return false;
        }
        if(!this.true_name){
            this.$toast.center(this.$t('level1.input-username'));
            return false;
        }
        if(!this.id_card || this.id_card == null){
            this.$toast.center(this.$t('level1.input-idcard'));
            return false;
        }
        if(this.isBank == 1){
          if(this.bank_name == null){
            this.$toast.center(this.$t('level1.qsrkhh'));
            return;
          }
          if(this.bank_number == null){
            this.$toast.center(this.$t('level1.qsryhkh'));
            return;
          }
        }
          if(this.count == 1){
            this.count = 0;
          }else{
              return false;
          }
          this.$ajax.post('/web/editCenterLevel',params).then((res) => {
              let resData = res.data;
              if(resData.code == 0 || resData.code == 4 || resData.code == 7){
                this.$toast.center(resData.message);
                setTimeout(() => {
                  this.count = 1;
                  this.$router.push('/user')
                }, 1000)
              }else{
                this.count = 1;
                this.$toast.center(resData.message);
                return;
              }

          }).catch(function(err){
              console.log(err)
          })
      }
    }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        color: #000;
        font-size: .56rem;
        line-height: 1.6rem;
        background: #fff;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .5rem;
        margin-top: -.4rem;
    }
    .head .jump{
        position: absolute;
        right: .44rem;
        top: 50%;
        color: #000;
        font-size: .48rem;
        transform: translateY(-50%);
    }
    .position-box{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #fff;
    }
    .cotainer{
        position: absolute;
        left: .45rem;
        right: .45rem;
        top: 1.6rem;
        bottom: 2.4rem;
        background: #fff;
        overflow-y: scroll;
    }
    .cotainer .tips{
        padding: .54rem 0 .26rem;
        color: #000;
        font-size: .4rem;
    }
    .cotainer .country-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: .64rem;
        padding: .48rem 0;
        border-bottom: 1px solid #ececec;
    }
    .cotainer .country-box .arrow{
        width: .22rem;
    }
    .cotainer .input-box{
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: .32rem 0;
        border-bottom: .01rem solid #ececec;
    }
    .cotainer .input-box .down{
        width: .6rem;
    }
    .cotainer .input-pwd{
        margin-top: .76rem;
    }
    .card-box{
        position: absolute;
        left: -1px;
        right: 0;
        bottom: 0;
        z-index: 1000;
        /* border: 1px solid #b3b3b3; */
        background: #fff;
        border-radius: .08rem;
    }
    .card-box .card{
        height: 1.2rem;
        color: #000;
        font-size: .42rem;
        line-height: 1.2rem;
        border-bottom: 1px solid #b3b3b3;
        text-align: center;
    }
    .card-box .card:last-child{
        border-bottom: none;
    }
    .cotainer .input-box .input{
        flex: 1;
        height: 100%;
        color: #000;
        font-size: .48rem;
    }
    .cotainer .input-box .input::placeholder{
        color: #d7d7d7;
        font-size: .42rem;
    }
    .cotainer .input-box .code{
        color: #588bf8;
        font-size: .48rem;
    }
    .cotainer .item-box{
        padding: .5rem .45rem .7rem;
    }
    .cotainer .item-box .item{
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: .4rem;
    }
    .cotainer .item-box .upload-box,.cotainer .item-box .upload-box .upload-bg,.cotainer .item-box .img{
        position: relative;
        width: 4.4rem;
        height: 2.6rem;
    }
    .cotainer .item-box .upload-box .text{
        position: absolute;
        width: 100%;
        bottom: .2rem;
        padding: 0 .15rem;
        color: #274865;
        font-size: .36rem;
        box-sizing: border-box;
        text-align: center;
    }
    .cotainer .tips-text{
        padding: 0 .45rem .2rem;
        color: #000;
        font-size: .36rem;
    }
    .btn-login{
      position: fixed;
      left: .45rem;
      right: .45rem;
      bottom: .6rem;
      width: 9.92rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/authentication.vue